module.exports = __webpack_public_path__ + "img/grey.ae3b7c23.webp";